import type { SRT_SortingState } from '@/shared/components/master-table'
import type { ProductCatalogModel } from '@/shared/generated'
import type { TableData } from '../model/types'

import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
	MasterTable,
	useMasterReactTable,
} from '@/shared/components/master-table'
import { getMasterTableLocale } from '@/shared/i18n'

import { getColumns } from '../lib/columns'

export default function AnchorsMasterTable({
	tableData,
	anchorProduct,
}: {
	tableData: TableData['anchors']
	anchorProduct: ProductCatalogModel | null
}) {
	const { t } = useTranslation()

	const [sorting, setSorting] = useState<SRT_SortingState>([])
	const columns = useMemo(() => getColumns(t), [])
	const table = useMasterReactTable({
		localization: getMasterTableLocale(),
		data: tableData,
		columns,
		state: {
			sorting,
		},
		getRowClassName: ({ row }) => {
			if (row.original.sku === anchorProduct?.sku) {
				return 'bg-muted pointer-events-none opacity-50'
			}

			return ''
		},
		layoutMode: 'grid',
		getRowId: (row) => row.sku,
		onSortingChange: setSorting,
		enableVirtualization: true,
		enableColumnResizing: true,
	})

	return (
		<MasterTable
			table={table}
			data-testid='modal-assign-to-anchor-management-table'
		/>
	)
}
